import Footer from './components/Footer';
import Navbar from './components/Navbar';
import Home from './components/pages/Home';
import { ViewportProvider } from './Context';
import ReactGA from 'react-ga';
import { useEffect } from 'react';
function App() {
  useEffect(() => {
    ReactGA.initialize('UA-108807921-23');
    
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  return (
    <ViewportProvider>
      <Navbar />
      <Home />
      <Footer />
    </ViewportProvider>
  );
}

export default App;
